<div class="d-flex align-items-center">
  <!-- Display Screen Status -->
  <ng-container *ngIf="params.screenType === SCREEN_TYPE.DISPLAY">
    <span
      nz-icon
      nzType="check-circle"
      nzTheme="fill"
      *ngIf="params.data?.isOnline"
      class="status-icon-success mr-2"
    ></span>
    <span *ngIf="params.data?.isOnline">Active</span>
    <span
      nz-icon
      nzType="close-circle"
      nzTheme="fill"
      *ngIf="!params.data?.isOnline"
      class="status-icon-danger mr-2"
    ></span>
    <span *ngIf="!params.data?.isOnline">In-active</span>
  </ng-container>
  <!-- Media App Status -->
  <ng-container *ngIf="params.screenType === SCREEN_TYPE.MEDIA_APP">
    <ng-template #defaultStatus>
      <span *ngIf="params.data?.status === 1" class="align-items-center">
        <span
          nz-icon
          nzType="check-circle"
          class="status-icon-success mr-2"
          nzTheme="fill"
        ></span
        >Enabled
      </span>
      <span *ngIf="params.data?.status === 2">
        <span
          nz-icon
          nzType="close-circle"
          class="status-icon-danger mr-2"
          nzTheme="fill"
        ></span
        >Hidden
      </span>
      <span *ngIf="params.data?.status === 4">
        <span
          nz-icon
          nzType="clock-circle"
          class="status-icon-primary mr-2"
          nzTheme="fill"
        ></span
        >Scheduled
      </span>
    </ng-template>
    <ng-container *ngIf="params.data.type == 10 && params.data?.videoEncodingStatus !== 3; else defaultStatus">
      <span nz-icon [nzType]="'loading'"
       class="icon-primary"
       nz-tooltip
       nzTooltipTitle="Video optimization in progress. We'll notify you when it's complete.">
      </span>&nbsp;<span>Optimizing</span>
    </ng-container>
  </ng-container>
  <!-- Media App Status -->
  <ng-container *ngIf="params.screenType === SCREEN_TYPE.BROADCAST">
    <div
      class="d-flex align-items-center"
      *ngIf="
        params.value == 1 ||
        params.value == 2 ||
        params.value == 5
      "
    >
      <span
        nz-icon
        nzType="clock-circle"
        class="status-icon-primary mr-1"
        nzTheme="fill"
      ></span>
      Scheduled
    </div>
    <div
      *ngIf="params.value == 3"
      class="d-flex align-items-center"
    >
      <span
        nz-icon
        nzType="clock-circle"
        class="status-icon-primary mr-1"
        nzTheme="fill"
      ></span>
      Triggered
    </div>
    <div
      *ngIf="params.value == 4"
      class="d-flex align-items-center"
    >
      <span
        nz-icon
        nzType="check-circle"
        class="status-icon-success mr-1"
        nzTheme="fill"
      ></span>
      Broadcasting
    </div>
    <div
      *ngIf="params.value == 6"
      class="d-flex align-items-center"
    >
      <span
        nz-icon
        nzType="close-circle"
        nzTheme="fill"
        class="status-icon-danger mr-1"
      ></span>
      Expired
    </div>
  </ng-container>
  <ng-container *ngIf="params.screenType === SCREEN_TYPE.GROUP">
    <span
      nz-icon
      nzType="check-circle"
      nzTheme="fill"
      class="status-icon-success mr-2"
      *ngIf="
        params.data.subscriptionStatus == 'Active' ||
        params.data.subscriptionStatus == 'InTrial'
      "
    ></span>
    <span
      nz-icon
      nzType="close-circle"
      nzTheme="fill"
      class="status-icon-inactive mr-2"
      *ngIf="
        params.data.subscriptionStatus != 'Active' &&
        params.data.subscriptionStatus != 'InTrial'
      "
    ></span>
    <span *ngIf="params.data.subscriptionStatus != 'InTrial'">{{
      params.data.subscriptionStatus
    }}</span>
    <span *ngIf="params.data.subscriptionStatus == 'InTrial'">Free Trial</span>
  </ng-container>

  <ng-container *ngIf="params.screenType === SCREEN_TYPE.DAILY_LOOP">
    <div class="d-flex align-items-center" *ngIf="params.value === 'Scheduled'">
      <span
        nz-icon
        nzType="clock-circle"
        class="status-icon-primary mr-1"
        nzTheme="fill"
      ></span>
      Scheduled
    </div>
    <div class="d-flex align-items-center" *ngIf="params.value === 'Active'">
      <span
        nz-icon
        nzType="play-circle"
        class="status-icon-success mr-1"
        nzTheme="fill"
      ></span>
      Active
    </div>
    <div class="d-flex align-items-center" *ngIf="params.value === 'Live'">
      <span
        nz-icon
        nzType="check-circle"
        class="status-icon-success mr-1"
        nzTheme="fill"
      ></span>
      Live
    </div>
    <div class="d-flex align-items-center" *ngIf="params.value === 'Expired'">
      <span
        nz-icon
        nzType="close-circle"
        class="status-icon-danger mr-1"
        nzTheme="fill"
      ></span>
      Expired
    </div>
  </ng-container>
</div>
